import {
    Button,
    Card,
    CardContent,
    Typography,
    IconButton,
    Box,
    Grid2,
    Icon,
    TextField,
    Link,
    Paper
} from "@mui/material";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useNavigate, useParams } from "react-router-dom";
import { FileTypeEnum } from "../../../_common/enum/fileType.enum";
import { IFilteringViewModel } from "../../../_common/interface/table";
import { StandardButton } from "../../../_components/button/primary.button";
import { StandardTextValidator } from "../../../_components/textValidator/standardTextValidator";
import { toastr } from "../../../_components/toastr/toastr";
import { handleErrorResponse } from "../../../_helpers/handleResponse.helper";
import { fileUploadService } from "../../../_services/fileUpload.service";
import { getEnumKey } from "../../../_helpers/enum.helper";
import { FileStatusIcon } from "./ticket-uploadsFileStatus";
import { StandardList } from "../../../_components/list/standardList.component";
import { StandardListItem } from "../../../_components/list/standardListItem.component";


export function CaseTicketUploadManage(params: { fileType: FileTypeEnum, onSave?: () => void, onClose(): void}) {

    const resetData = () => ({});

    const { caseId, ticketId } = useParams<{ caseId: string, ticketId: string }>();
    const { fileType } = params;
    const [upload, updateUpload] = useState<{ ticketId: number | null, fileTypeId: number | null, file: any | null }>({ ticketId: 0, fileTypeId: 0, file: null });
    const [data, setData] = useState<any>(resetData);
    const [isLoading, setIsLoading] = useState(false);
    const [saving, setIsSaving] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [ticketFiles, setTicketFiles] = useState<any[]>([]);
    const [filter, setFilter] = useState<IFilteringViewModel>({
        ticketId: fileType === FileTypeEnum.Ticket ? ticketId : null,
        caseId: fileType === FileTypeEnum.Case ? caseId : null,
    });


    useEffect(() => {
        if (caseId != null) fetchData();
        else setData(resetData);
    }, [caseId]);


    function fetchData() {
        setIsLoading(true);
        return fileUploadService.getAll(fileType, filter)
            .then(
                data => {
                    setTicketFiles(data.items);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    }

    function onUploadChange(event: any) {
        const _upload = upload
        _upload.file = event.target.files[0];
        updateUpload({ ..._upload });
    }

    function submit(e: any) {
        e.preventDefault();
        setIsSaving(true);

        const formData = new FormData();
        formData.append("file", upload.file);

        //get the id type we need based on the FileType -> caseId, ticketId, etc
        formData.append(getEnumKey(fileType, FileTypeEnum).toLowerCase() + "Id", (caseId || 0)?.toString());
        formData.append("fileTypeId", (fileType || 0)?.toString());
        formData.append("caseId", caseId || "");

        return fileUploadService
            .uploadFile(formData)
            .then(
                () => {
                    toastr.success("File Upload was successful.");
                    setData(resetData());
                    setShowForm(false);
                    fetchData();
                    params.onClose?.();
                },
                handleErrorResponse
            )
            .finally(() => setIsSaving(false));
    }

    function disable(id: string) {
        if (!id) return;
        setIsLoading(true);

        console.log("disable", id);

        return fileUploadService
            .disable(id)
            .then(
                () => {
                    toastr.success("File deleted successfully");
                    fetchData();

                    if (fileType === FileTypeEnum.Case)
                        params.onSave?.();
                },
                handleErrorResponse
            )
            .finally(() => setIsLoading(false));
    }

    function download(id: string) {
        console.log("download", id);
        return fileUploadService.download(id);
    }

    const addNew = () => {
        setData(resetData());
        setShowForm(true);
    };

    const cancel = () => {
        setShowForm(false);
        setData(resetData());
    };
    const [searchTerm, setSearchTerm] = useState("");
    const filteredFiles = ticketFiles.filter(file =>
        file.fileName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>


            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} p={2}>
                <Typography variant="h6"></Typography>
                <Box display="flex" alignItems="center" flexGrow={1} mr={2}>
                    <TextField
                        variant="outlined"
                        size="small"
                        placeholder="Search files..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        fullWidth
                    />
                </Box>
                {!showForm && (
                    <Button variant="contained" onClick={addNew}>
                        Add File
                    </Button>
                )}
            </Box>

            {showForm && (
                <ValidatorForm onSubmit={submit} noValidate >
                    <Grid2 container spacing={2} mb={2 }>
                        <Grid2 size={{ xs: 12 }}>
                            <TextField
                                label="File to Upload"
                                type="file"
                                id="TicketFile"
                                required
                                fullWidth
                                onChange={onUploadChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid2>
                        <Grid2 size={{ xs: 6 }}>
                            <StandardButton
                                saving={saving}
                                loading={isLoading}
                                icon="save"
                                type="submit"
                            >
                                Save
                            </StandardButton>
                        </Grid2>
                        <Grid2 size={{ xs: 6 }}>
                            <StandardButton
                                saving={saving}
                                loading={isLoading}
                                icon="block"
                                variant="error"
                                onClick={cancel}>
                                Cancel
                            </StandardButton>
                        </Grid2>
                    </Grid2>
                </ValidatorForm>
            )}
            <StandardList isLoading={isLoading}>
                {(!isLoading && !!ticketFiles.length) && filteredFiles.map((item: any, index: number) => (
                    <StandardListItem
                        primary={item.fileName}
                        secondary={
                            <FileStatusIcon stateId={item.fileUploadStateId} />
                        }
                        buttons={[
                            { icon: "download", onClick: () => download(item.fileUploadId), variant: "primary" },
                            { icon: "delete", onClick: () => disable(item.fileUploadId), variant: "error" },
                        ]}
                        key={item.id}

                    />

                ))}

            </StandardList>

        </>

    );
}
